


























































































































































































































































































































































































import Vue from "vue";
import * as types from "../../store/types";
import { rules, scrollToFirstInvalidElement } from "../../services/validation";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "ApplicationStep5",

  props: {},

  data: () => {
    return {
      rules,
      usesInvalid: false,
      requiredComplianceFalse: (value: boolean) =>
        !value || "Sorry, you do not qualify to receive federal funding.",
      requiredCompliance: (value: boolean) =>
        value ||
        "Sorry, you must agree to these conditions in order to submit your application.",
      expenditureCategories: [
        "Mental Health Services",
        "Housing Support: Affordable Housing",
        "Housing Support: Services for Unhoused Persons",
        "COVID-19 Vaccination",
        "Small Business Economic Assistance",
        "Aid to Nonprofit Organizations",
        "Household Assistance: Food Programs",
        // "Broadband: “Last Mile” Projects",
        "Healthy Childhood Environments: Child Care",
        "Healthy Childhood Environments: Services to Foster Youth",
        // "Water and Sewer",
        // "Specify, if possible, the eligible infrastructure category",
        "Aid to Tourism, Travel, or Hospitality",
        "Other",
      ],
      formValue: {
        requestedAmount: "",
        briefDescription: "",
        communityNeed: "",
        typeOfProject: "",
        whoBenefits: "",
        howManyServed: "",
        howManyServedGcmo: "",
        howRespondOrRecover: "",
        howRecover: "",
        howFundsUsed: "",
        expenditureCategoriesOther: "",
        accordance: "",
        totalRequested: "",
        totalCost: "",
        receivedRelatedFundsPercentage: "",
        longtermMaintenance: "",
        assistUnderservedHow: "",
        placedUnderservedHow: "",
        expenditureCategories: "",
        utilizationEconomic: null,
        utilizationHealth: null,
        utilizationCommunities: null,
        complianceExpenditures: null,
        complianceBenefitGcmo: null,
        complianceExpendituresExplain: "",
        complianceBenefitGcmoExplain: "",
        receivedRelatedFunds: null,
        requestBudgeted: null,
        complianceSuspended: null,
        complianceLoanDelinquence: null,
        assistUnderserved: null,
        placedUnderserved: null,
      },
    };
  },

  methods: {
    ...mapActions({
      saveStep: types.SAVE_FORM_STEP,
    }),
    saveAndContinue() {
      this.saveStep({
        formFields: this.formValue,
      }).then(() => {
        // sometimes this if firing before the application-level validation, which reset the validation state, so we wait a little longer to be safe.
        setTimeout(() => {
          if (!this.validateUses())
            return this.$smoothScroll({
              // @ts-ignore
              scrollTo: this.$refs.form.$el,
            });

          // @ts-ignore
          const isValid = this.$refs.form.validate();
          this.$emit("update-validity", 4, isValid);
          if (!isValid) {
            return scrollToFirstInvalidElement(this, this.$refs.form as Vue);
          }

          this.$emit("next-step");
        }, 500);
      });
    },
    save() {
      this.saveStep({
        formFields: this.formValue,
      });
    },
    updateValidity() {
      // @ts-ignore
      const formIsValid = this.$refs.form.validate();
      // @ts-ignore
      this.$refs.form.resetValidation();

      this.$emit("update-validity", 4, formIsValid);
    },
    validateUses() {
      this.usesInvalid =
        !this.formValue.utilizationEconomic &&
        !this.formValue.utilizationHealth;

      return !this.usesInvalid;
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
      saving: types.SAVING_FORM,
    }),
    expenditureCategoriesValue: {
      get(): string[] {
        return this.formValue.expenditureCategories.split(";");
      },
      set(value: string[]) {
        this.formValue.expenditureCategories = value.join(";");
      },
    },
  },

  watch: {
    allFormValues: {
      immediate: true,
      handler() {
        // map this step's fields to Vuex's
        Object.keys(this.formValue).forEach(
          // @ts-ignore
          (key) => (this.formValue[key] = this.allFormValues[key])
        );

        setTimeout(() => this.updateValidity(), 50);
      },
    },
  },
});
